import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=839319aa&scoped=true"
import script from "./ReportsTable.vue?vue&type=script&lang=js"
export * from "./ReportsTable.vue?vue&type=script&lang=js"
import style0 from "./ReportsTable.vue?vue&type=style&index=0&id=839319aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839319aa",
  null
  
)

export default component.exports